import { Link } from "react-router-dom";
import { Instagram, Facebook, Linkedin, MapPin, Phone, Mail, ArrowUpRight } from "lucide-react";
import { BUSINESS } from "@/lib/config";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative bg-espresso text-warm-ivory grain overflow-hidden">
      <div className="mx-auto max-w-[1500px] px-6 md:px-12 py-24 md:py-32 relative z-10">
        <div className="grid md:grid-cols-12 gap-12 md:gap-8">
          <div className="md:col-span-6">
            <div className="flex items-center gap-4 mb-6">
              <span className="champagne-rule" />
              <span className="fine-uppercase text-[0.68rem] text-champagne">Sutra Studio</span>
            </div>
            <h3 className="font-display text-5xl md:text-6xl lg:text-7xl leading-[0.98]">
              Let&apos;s compose<br />your <span className="italic text-champagne font-normal">home.</span>
            </h3>
            <Link
              to="/book-consultation"
              data-testid="footer-book-btn"
              className="mt-10 group inline-flex items-center gap-3 border border-champagne text-champagne fine-uppercase text-[0.72rem] px-8 py-4 hover:bg-champagne hover:text-espresso transition-colors duration-500"
            >
              Private Consultation
              <ArrowUpRight size={14} strokeWidth={1.6} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
            </Link>
          </div>

          <div className="md:col-span-2 md:col-start-8">
            <p className="fine-uppercase text-[0.62rem] text-champagne mb-6">Studio</p>
            <ul className="space-y-3 text-[0.9rem] text-warm-ivory/65 font-light">
              {[["About", "/about"], ["Collections", "/services"], ["Projects", "/gallery"], ["Voices", "/testimonials"], ["Journal", "/blog"], ["Contact", "/contact"]].map(([label, to]) => (
                <li key={to}><Link to={to} className="hover:text-champagne transition-colors">{label}</Link></li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="fine-uppercase text-[0.62rem] text-champagne mb-6">Contact</p>
            <ul className="space-y-4 text-[0.9rem] text-warm-ivory/65 font-light">
              <li className="flex gap-3"><MapPin size={14} className="text-champagne shrink-0 mt-1" /><span className="leading-relaxed">{BUSINESS.address}</span></li>
              <li className="flex gap-3"><Phone size={14} className="text-champagne shrink-0 mt-1" /><a href={`tel:${BUSINESS.phoneRaw}`} className="hover:text-champagne">{BUSINESS.phone}</a></li>
              <li className="flex gap-3"><Mail size={14} className="text-champagne shrink-0 mt-1" /><a href={`mailto:${BUSINESS.email}`} className="hover:text-champagne">{BUSINESS.email}</a></li>
            </ul>
            <div className="flex gap-5 mt-8">
              <a href={BUSINESS.social.instagram} target="_blank" rel="noreferrer" aria-label="Instagram" className="text-warm-ivory/60 hover:text-champagne transition-colors"><Instagram size={17} strokeWidth={1.3} /></a>
              <a href={BUSINESS.social.facebook} target="_blank" rel="noreferrer" aria-label="Facebook" className="text-warm-ivory/60 hover:text-champagne transition-colors"><Facebook size={17} strokeWidth={1.3} /></a>
              <a href={BUSINESS.social.linkedin} target="_blank" rel="noreferrer" aria-label="LinkedIn" className="text-warm-ivory/60 hover:text-champagne transition-colors"><Linkedin size={17} strokeWidth={1.3} /></a>
            </div>
          </div>
        </div>

        <div className="mt-24 pt-8 hairline-light border-t flex flex-col md:flex-row justify-between gap-4 text-[0.72rem] text-warm-ivory/45 font-light">
          <span>© {new Date().getFullYear()} {BUSINESS.name}. Bespoke luxury interiors, Kolkata.</span>
          <div className="flex gap-6">
            <Link to="/privacy" className="hover:text-champagne transition-colors">Privacy</Link>
            <Link to="/terms" className="hover:text-champagne transition-colors">Terms</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
